import React from 'react'
import { DataBlock } from '@fs/zion-ui'
import FieldWrapper from '../../ui/FieldWrapper'

const FieldDisplay = ({ field, value }) => {
  if (field?.typeData && !field?.typeData?.displayable && !field?.typeData?.editable) return null // https://fhjira.churchofjesuschrist.org/browse/RIP-2006

  return (
    <FieldWrapper>
      <DataBlock inline key={field?.id} data={`${field.label}: ${value || ''}`} heading="" />
    </FieldWrapper>
  )
}

export default FieldDisplay
